import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';

@Component({
  selector: 'neo-matris-dropdown',
  templateUrl: './matris-dropdown.component.html',
  styleUrls: ['./matris-dropdown.component.scss']
})
export class MatrisDropdownComponent {

  @Input() options: any[] = [];
  @Input() optionLabel: string
  @Input() optionValue: string
  @Input() selectedOption: any
  @Input() showClear: boolean = false;
  @Input() loading: boolean = false;
  @Input() placeholder: any
  @Input() isDisabled: any
  @Input() dropdownLabel: any
  @Input() id: any;
  @Input() autoDisplayEnabled: any;
  @Input() filter: any;
  @Input() customStyle: any = {};
  @Input() virtualScroll: boolean = false;
  @Input() virtualScrollItemSize: any;
  @Input() showError: boolean;
  @Input() showTooltip: boolean = false;
  @Input() showLabel: boolean = true;
  @Input() isRequired: boolean = false; 
  
  @Input() showInfoIcon: boolean = false;
  @Input() infoTooltip: string = '';
  @Input() infoIconClass: string = 'pi pi-info-circle';   // PrimeIcons
  @Input() infoTooltipPosition: 'top' | 'right' | 'bottom' | 'left' = 'right';
  @Input() errorMessage: string = '';

  @Output() dropdownChange = new EventEmitter<any>()
  @ViewChild('dropdownPanel') dropdownPanel!: Dropdown;
  constructor(private cdr: ChangeDetectorRef) {}

  onChange(event: any) {
    this.dropdownChange.emit({ id: this.id, event: event })
  }

}
